import * as angular from "angular";
import {IController} from "angular";

export class WeightCapacityComponent implements IController {
  weightLoad: any;
  maxLoad: any;

  constructor() {
  }

}

angular
  .module('bringoz.admin.commons')
  .component('weightCapacity', {
    bindings: {
      weightLoad: '<',
      maxLoad: '<'
    },
    templateUrl: 'app/modules/commons/components/weight-capacity/weight-capacity.html',
    controller: WeightCapacityComponent
  });
